import { animate, spring } from "motion";

function initAnimNewsCircle() {
  const newsItems = document.querySelectorAll(".news-item");

  newsItems.forEach((item) => {
    const circle = item.querySelector(".yellow-circle-news");

    item.addEventListener("mouseenter", () => {
      animate(
        circle,
        {
          opacity: 1,
          translateX: -40,
          translateY: -40,
        },
        {
          duration: 0.1,
          easing: spring({ stiffness: 500, damping: 25 }),
        }
      );
    });

    item.addEventListener("mouseleave", () => {
      animate(
        circle,
        {
          opacity: 0,
          translateX: 0,
          translateY: 0,
        },
        {
          duration: 0.2,
          easing: "ease-out",
        }
      );
    });
  });
}

export { initAnimNewsCircle };

function initAnimNewsPageCircle() {
  const isFrontPage = document.body.classList.contains("blog");

  if (!isFrontPage) {
    return;
  }

  const circle = document.querySelector(".yellow-news-circle");

  const getAnimationValues = () => {
    if (window.innerWidth < 1028) {
      return {
        translateX: -80,
        translateY: -50,
      };
    } else {
      return {
        translateX: -100,
        translateY: -140,
      };
    }
  };

  // Initial animation
  animate(circle, getAnimationValues(), {
    duration: 0.1,
    easing: spring({ stiffness: 500, damping: 25 }),
  });

  // Update animation on window resize
  window.addEventListener("resize", () => {
    animate(circle, getAnimationValues(), {
      duration: 0.1,
      easing: spring({ stiffness: 500, damping: 25 }),
    });
  });
}

export { initAnimNewsPageCircle };

function initAnimNewsPageTitle() {
  const isNewsPage =
    document.body.classList.contains("blog") ||
    document.body.classList.contains("post-type-archive-event");

  if (!isNewsPage) {
    return;
  }

  const title = document.querySelector(".news-page-title");

  animate(
    title,
    {
      translateY: -200,
    },
    {
      duration: 0.1,
      easing: spring({ stiffness: 500, damping: 25 }),
    }
  );
}

export { initAnimNewsPageTitle };

function initAnimNewsItems() {
  const isBlogPage = document.body.classList.contains("blog");

  if (!isBlogPage) {
    return;
  }

  const posts = document.querySelectorAll(".animate-post-in-list");

  posts.forEach((post) => {
    animate(
      post,
      {
        translateX: -200,
        translateY: -300,
      },
      {
        duration: 0.2,
        easing: spring({ stiffness: 400, damping: 25 }),
      }
    );
  });
}

export { initAnimNewsItems };

function initAnimFrontCircle() {
  const isFrontPage = document.querySelector(".front-circle");

  if (!isFrontPage) {
    return;
  }

  const circle = document.querySelector(".yellow-circle-wrapper");

  const getAnimationValues = () => {
    if (window.innerWidth < 1028) {
      return {
        translateX: 80,
        translateY: 80,
      };
    } else {
      return {
        translateX: 80,
        translateY: 110,
      };
    }
  };

  // Initial animation
  animate(circle, getAnimationValues(), {
    duration: 0.1,
    easing: spring({ stiffness: 500, damping: 25 }),
  });

  // Update animation on window resize
  window.addEventListener("resize", () => {
    animate(circle, getAnimationValues(), {
      duration: 0.1,
      easing: spring({ stiffness: 500, damping: 25 }),
    });
  });
}

export { initAnimFrontCircle };

function initAnimCalendarHeader() {
  const isPage = document.body.classList.contains("post-type-archive-event");

  if (!isPage) {
    return;
  }

  const header = document.querySelector(".fc-header-toolbar");

  animate(
    header,
    {
      translateY: 40,
    },
    {
      duration: 0.1,
      easing: spring({ stiffness: 500, damping: 25 }),
    }
  );
}

export { initAnimCalendarHeader };

function initAnimTitle() {
  const isPresent = document.querySelector(".animate-title");

  if (!isPresent) {
    return;
  }

  const titles = document.querySelectorAll(".animate-title");

  titles.forEach((title) => {
    animate(
      title,
      {
        translateY: -80,
      },
      {
        duration: 0.5,
        easing: spring({ stiffness: 500, damping: 25 }),
      }
    );

    animate(
      title,
      {
        opacity: 1,
      },
      {
        duration: 0.2,
        easing: "ease-in-out",
      }
    );
  });
}

export { initAnimTitle };
